import { useDebounce } from "@uidotdev/usehooks";
import { useCallback, useMemo, useRef, useState } from "react";

export const useMessageSearch = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText.trim(), 400);
  const inputRef = useRef(null);
  const [selectedFocus, setSelectedFocus] = useState(null);

  const isSearching = searchOpen && Boolean(debouncedSearchText);

  const open = useCallback(() => {
    setSearchOpen(true);
    setTimeout(() => inputRef.current?.focus(), 50);
  }, []);

  const close = useCallback(() => {
    setSearchOpen(false);
    setSearchText("");
  }, []);

  const clear = useCallback(() => setSearchText(""), []);

  const selectResult = useCallback((message) => {
    setSearchOpen(false);
    setSearchText("");
    setSelectedFocus({ uid: message.uid, requestKey: `${message.uid}:${Date.now()}` });
  }, []);

  const consumeFocus = useCallback(() => setSelectedFocus(null), []);

  return useMemo(
    () => ({
      searchOpen,
      searchText,
      debouncedSearchText,
      isSearching,
      inputRef,
      selectedFocus,
      open,
      close,
      clear,
      setSearchText,
      selectResult,
      consumeFocus,
    }),
    [searchOpen, searchText, debouncedSearchText, isSearching, selectedFocus, open, close, clear, selectResult, consumeFocus],
  );
};
